export default "__VITE_ASSET__DtnNv0L9__"